export { default as YouTubePlayer } from './YouTubePlayer';
